<template>
  <!--
  <RadioGroup v-model="model" class="">
    <RadioGroupLabel class="radio-filter-group__label mr-2">
      <span class="block truncate">Sport</span>
    </RadioGroupLabel>
    <div
      class="inline-flex flex-wrap items-center gap-2 bg-neutral-100 dark:bg-neutral-600 rounded-md py-1 m-[10px_0_10px_-10px]"
    >
      <RadioGroupOption v-slot="{ checked }" :value="'baseball'">
        <span
          class="px-4 py-2 text-base font-medium rounded-md cursor-pointer border border-transparent hover:border-gray-200 dark:hover:border-neutral-500"
          :class="{
            'bg-neutral-200 dark:bg-white text-black': checked,
            'md:px-3 md:py-1': size !== 'normal',
          }"
          >Baseball</span
        >
      </RadioGroupOption>
      <RadioGroupOption v-slot="{ checked }" :value="'softball'">
        <span
          class="px-4 py-2 text-base font-medium rounded-md cursor-pointer border border-transparent hover:border-gray-200 dark:hover:border-neutral-500"
          :class="{
            'bg-neutral-200 dark:bg-white text-black': checked,
            'md:px-3 md:py-1': size !== 'normal',
          }"
          >Softball</span
        >
      </RadioGroupOption>
    </div>
  </RadioGroup>
-->
  <NewBadgeWrapper>
    <FormKit
      type="select"
      label="Sport"
      v-model="model"
      :options="sportOptions"
    />
  </NewBadgeWrapper>
</template>

<script lang="ts" setup>
// import { RadioGroup, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue';

// defineModel for default value
const model = defineModel<Sport>({ required: true });
interface Props {
  size?: 'sm' | 'normal';
}

const sports = [{ label: 'Baseball' }, { label: 'Softball' }];

const sportOptions = computed(() => {
  return sports.map((sport) => ({ label: sport.label, value: sport.label }));
});

const props = withDefaults(defineProps<Props>(), {
  size: 'normal',
});

// const emit = defineEmits(['update:modelValue']);
// const { modelValue } = useVModels(props, emit);
</script>
